export default () => {
  document.addEventListener("turbolinks:load", () => {
    const images = document.querySelectorAll('.admin input.upload-image');

    if (images.length > 0) {
      images.forEach(image => {
        const parentElement = image.closest('.m-auto');
        if (parentElement) {
          const preview = parentElement.querySelector('.image-preview');
          
          if (preview) {
            image.addEventListener('change', () => {
              const file = image.files[0];
              if (file) {
                const reader = new FileReader();
                
                reader.onload = (e) => {
                  preview.style.backgroundImage = 'url(' + e.target.result + ')';
                }
                reader.readAsDataURL(file);
              }
            });
          }
        }
      });
    }
  });
};
